import { render, staticRenderFns } from "./AdminQueryDetails.vue?vue&type=template&id=698e97e8&scoped=true&"
import script from "./AdminQueryDetails.vue?vue&type=script&lang=js&"
export * from "./AdminQueryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698e97e8",
  null
  
)

export default component.exports